import { DynamicDropdowns } from './DinamicDropdowns';

export default DynamicDropdowns;
